// extracted by mini-css-extract-plugin
module.exports = {"arrow":"lK","dropMenu":"lL","dropMenuInner":"lM","itemborder":"lN","dropDownCurrent":"lO","menuItem":"lP","langContainer":"lQ","current":"lR","outlink":"lS"};